import React from 'react'
import { Anchor, Image, Paper, Stack, Title } from '@mantine/core'
import SocialMedia from './SocialMedia'

/**
 * Renders a panel with company information and social media links.
 * @param {object} landingPage The landing page related to the company.
 * @returns {JSX.Element}
 */
function CompanyInformation ({ landingPage }) {
  return (
    <Stack>
      <Title order={3} c='gray.8'>Company Information</Title>
      <Paper bg={landingPage.company_information_background_color}>
        <Stack
          align="center"
          justify="center"
          gap="xs"
        >
          <Image
            mah={60}
            alt="Company logo"
            href={landingPage.company_website}
            width="auto"
            fit="contain"
            src={landingPage.logo}
          />
          <Title order={4} c={landingPage.company_information_text_color} ta='center'>{landingPage.company_name}</Title>
          {landingPage.company_website && (
            <Anchor
              href={landingPage.company_website}
              target="_blank"
              underline="never"
              size="sm"
              c={landingPage.company_information_text_color}
            >
              Visit Our Main Site
            </Anchor>
          )}
          <SocialMedia socialMedia={landingPage.social_media} color={landingPage.company_information_text_color} />
        </Stack>
      </Paper>
    </Stack>
  )
}

export default React.memo(CompanyInformation)
